export default "/images/vendor/flag-icon-css/flags/1x1/iq.svg?942b6bfdf031d606c26a1bf20b47c9a6";